import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { createProcedureInitiativeViewStaticData } from "src/views/CreateProcedureInitiativeView/constants"
import { CreateProcedureInitiativeView } from "src/views/CreateProcedureInitiativeView/CreateProcedureInitiativeView"
import * as z from "zod"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create",
)({
	component: CreateProcedureInitiativeView,
	staticData: createProcedureInitiativeViewStaticData,
	validateSearch: zodValidator(
		z.object({
			redirect: z.string().optional(),
			asset_type: z.string().optional(),
			procedure_type: z.string().optional(),
		}),
	),
})
